import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@softmax/design-system";

export type CreditRequest = {
  readonly id: string;
  readonly coworld: string;
  readonly when: string;
  readonly episodes: number;
  readonly credits: string;
};

export function CreditRequests({
  rows,
}: {
  readonly rows: readonly CreditRequest[];
}) {
  return (
    <TableContainer aria-label="Recent experience requests">
      <Table aria-label="Recent experience requests">
        <TableHead>
          <TableRow>
            <TableHeaderCell scope="col">Coworld</TableHeaderCell>
            <TableHeaderCell scope="col">Time</TableHeaderCell>
            <TableHeaderCell scope="col" align="end">
              Episodes
            </TableHeaderCell>
            <TableHeaderCell scope="col" align="end">
              Credits
            </TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.coworld}</TableCell>
              <TableCell>{row.when}</TableCell>
              <TableCell align="end">{row.episodes}</TableCell>
              <TableCell align="end">{row.credits}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
